import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomDropdown from 'components/CustomDropdown';
import { style } from 'constant/constants';
import {
  fenceCalculatorUIFieldStructure,
  fieldType,
  functions,
  getSelectedBrktPrice,
  getSystemComponents,
  handleInputValidation,
  isNameInSate,
  outputArray,
  setCartDataforAdd,
  sortFences,
  updateNewStateManuallyForSkippedSteps
} from './FenceCalcHelper';
import Input from 'components/Input';
import Text from 'components/Text';
import { combineFenceOutput } from 'pages/fenceCalculator/fenceCalculations';
import {
  allowSecondClick,
  getArrayOfValuesFromMap,
  handleInputError,
  handleKeyDown,
  isAdmin,
  isObjectEmpty,
  isUser,
  isValidNumber,
  preventChars,
  stylesInput
} from 'utils/utils';
import { useSelector } from 'react-redux';
import BackButton from 'components/BackButton';
import { authPostRequest } from 'Api/api';
import { BRACKET_MATERIALS, SYSTEM_COMPONENT_TYPES } from 'constant/enums';
import SortDropdownFence from 'components/SortDropdownFence';
import CustomButton from 'components/Button';
import { ArrowForward } from '../../../node_modules/@mui/icons-material/index';
import { getObjectWithValidValues } from 'pages/calculator/calculatorUtils';
import Loader from 'components/Loader';
import RoofSectionHeader from 'components/RoofSectionHeader';
import SuccessError from 'components/SuccessError';
import CalculatorCart from 'components/CalculatorCart';
import { getformattedCartData } from 'components/FenceCartContent';
import SaveScreenshot from 'components/SaveScreenshot';
import RenderOptionImages from 'components/RenderOptionImages';
import { useRef } from 'react';
import { FenceDiagram } from './FenceDiagram';
import SnowloadImage from 'components/SnowloadImage';

const schema = { data: '', value: '', name: null, apiCalled: false };
let priceList = [];

const FenceCalculator = () => {
  // generic data
  const navigate = useNavigate();
  const location = useLocation();
  const roofState = location.state;
  const roofData = roofState?.roofData;
  const roofName = roofData?.name?.trim();
  const roofDescription = roofData?.description?.trim();
  const projectId = roofState?.projectId;
  const projectName = roofState?.projectName;
  const roofId = roofData?.id;
  const enableGraph = true;

  // states
  const [fenceCalculatorState, setFenceCalculatorState] = useState(new Map([[0, { ...schema }]]));
  const [html, setHtml] = useState([]);
  const [strength, setStrength] = useState();
  const [barSystemValue, setBarSystemValue] = useState(null);
  const [fenceInfo, setFenceInfo] = useState(null);
  const [inputsArray, setInputsArray] = useState([]);
  const [outputs, setOutputs] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);
  const [dataForCart, setDataForCart] = useState([]);
  const [cartData, setCartData] = useState([]);
  const [sortByMaterial, setSortByMaterial] = useState(BRACKET_MATERIALS.ROW_STEEL);
  const [showLoader, setShowLoader] = useState();
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const [showAlertBar, setShowAlertBar] = useState(false);
  const [enableFinishBtn, setEnableFinishBtn] = useState(null);
  const [fenceQuotationId, setFenceQuotationId] = useState(null);
  const [isCalcInEditMode, setIsCalcInEditMode] = useState(false);
  const [lastClickTime, setLastClickTime] = useState(0);
  const [systemComponents, setSystemComponents] = useState(false);
  const [brktMaterialForEdit, setBrktMaterialForEdit] = useState(false);
  const [selectedBrktPrice, setSelectedBrktPrice] = useState(0);
  const [isClampOnFastener, setIsClampOnFastener] = useState(false);
  const [isStandingSeamConstruction, setIsStandingSeamConstruction] = useState(false);
  const [showSnowLoadImage, setShowSnowLoadImage] = useState(false);

  // data from store
  const { userData, storeData, adminAccess, readOnly } = useSelector((store) => store.auth);
  // refs
  const contentRef = useRef(null);

  // store id is at different places form super admin / area admin and others
  const storeID = adminAccess
    ? storeData?.id
    : isUser(userData?.roles) || isAdmin(userData?.roles)
      ? userData?.storesList[0]?.storeId
      : null;

  // change handlers
  const handleInputChange = (key, event, name, type, min, max) => {
    setIsCalcInEditMode(false);
    handleError(name, null);
    handleChange(key, event.target.value, name, type, min, max);
  };

  const handleDropdownChange = (key, event, dataArray, type) => {
    setInputsArray([]);
    setInputsArray([]);
    setShowSnowLoadImage(false);

    const value = event;
    const currentArr = dataArray?.filter((obj) => obj.id === value || obj.name === value);
    const name = currentArr[0]?.name;
    setErrors({});

    if (name.includes('Standing Seam')) {
      setIsStandingSeamConstruction(true);
    }

    handleChange(key, value, name, type, null, null);
  };

  const handleDropdownChangeMaterial = (key, event, dataArray) => {
    setIsCalcInEditMode(false);
    const value = event;
    const currentArr = dataArray?.filter((obj) => obj.id === value || obj.name === value);
    const name = currentArr[0]?.name;

    handleMaterial(key, value, name, dataArray);
  };

  const handleChange = (key, value, name, type, min, max) => {
    setIsCalcInEditMode(false);
    let invalidInput;
    if (type == 'number') {
      setInputsArray((prevState) => {
        const newArray = prevState;
        newArray[key - 8] = value;
        return newArray;
      });
      // eslint-disable-next-line prettier/prettier
      invalidInput = handleInputValidation(name, value, min, max, handleError);
      if (invalidInput) setOutputs([]);
    }
    setFenceCalculatorState((prevState) => {
      const newState = new Map([...prevState]);
      newState.forEach((value, tempKey) => {
        if (tempKey > key && type === 'select') {
          newState.delete(tempKey);
        }
      });
      const tempState = newState.get(key);
      newState.set(key, { ...tempState, value: value, name: name });
      if (type !== 'number' || (!fenceCalculatorState.get(key + 1)?.value && !invalidInput)) {
        const result =
          name === 'groundSnowLoad' && !isCalcInEditMode ? { ...schema, value: 0 } : { ...schema };
        newState.set(key + 1, result);
      }
      return newState;
    });
  };
  // other functions
  const handleMaterial = (key, value, name = null, material) => {
    setFenceCalculatorState((prevState) => {
      const newState = new Map([...prevState]);
      newState.forEach((value, tempKey) => {
        if (tempKey > key) {
          newState.delete(tempKey);
        }
      });
      const tempState = newState.get(key);

      newState.set(key, {
        ...tempState,
        value: value,
        name: name,
        data: material,
        apiCalled: true
      });
      newState.set(key + 1, { ...schema });

      return newState;
    });
  };

  const handleError = (input, errorMessage) => {
    handleInputError(input, errorMessage, setErrors);
  };

  //render when no data in current state
  const addNextField = (key) => {
    if (!fenceCalculatorState.get(key + 1)) {
      setFenceCalculatorState((prevState) => {
        const newState = new Map([...prevState]);
        newState.set(key + 1, { ...schema });
        return newState;
      });
    }
  };

  //for material prices
  const getBracketswithStorePrice = async () => {
    priceList = [];
    try {
      const bracketPriceRes = await authPostRequest('getBracketsWithStorePrice', {
        storeId: storeID,
        bracketTypeId: 60 // for snow bracket types
      });
      if (bracketPriceRes.resStatus === 1) {
        priceList = bracketPriceRes.bracketsList;
        isCalcInEditMode &&
          setSelectedBrktPrice(getSelectedBrktPrice(priceList, brktMaterialForEdit));
        sortFences(
          priceList,
          sortByMaterial,
          setUpdatedData,
          fenceCalculatorState,
          setDataForCart,
          isCalcInEditMode,
          setBarSystemValue
        );
      }
    } catch (err) {
      console.log(err, 'here is the error');
    }
  };

  //it renders the fields and push the dropdown into the html
  async function processFenceCalculatorState() {
    for (const [key, value] of fenceCalculatorState) {
      isClampOnFastener && setIsClampOnFastener(false);
      if (14 <= key) {
        const mapValuesArray = getArrayOfValuesFromMap(fenceCalculatorState);

        const inputValuesArray = [];

        for (let i = 8; i <= mapValuesArray.length - (isCalcInEditMode ? 1 : 1); i++) {
          inputValuesArray.push(mapValuesArray[i]);
        }
        setInputsArray(inputValuesArray);
        if (key === 14) break;
      }

      const newState = value;
      const fieldSchema = fenceCalculatorUIFieldStructure[key];

      if (!value.apiCalled && fieldSchema.api) {
        const params = [];
        const namesArr = [];

        for (let i = 0; i < fenceCalculatorState.size; i++) {
          const stateItem = fenceCalculatorState.get(i);
          namesArr.push(stateItem.name);
          params.push(stateItem.value);
        }

        if (fieldSchema.label !== 'Bracket Strength') {
          if (
            fieldSchema.label === 'Construction Type' &&
            isNameInSate(fenceCalculatorState, 'Standing Seam', 0) &&
            !isCalcInEditMode
          ) {
            setIsStandingSeamConstruction(true);
            newState.data = await functions[fieldSchema.api](params);
            updateNewStateManuallyForSkippedSteps(newState, key, handleChange);
          } else if (
            fieldSchema.label === 'Fastener Type' &&
            isNameInSate(fenceCalculatorState, 'Clamp', 2)
          ) {
            // calling fastener api, setting value to null and
            // marking apiCalled as true to move to next field
            newState.data = await functions[fieldSchema.api](params);
            updateNewStateManuallyForSkippedSteps(newState, key, handleChange);
          } else {
            newState.data = await functions[fieldSchema.api](params);
            setIsStandingSeamConstruction(false);
          }
        }
        setUpdatedData(newState.data);
        const inputsArr = getArrayOfValuesFromMap(fenceCalculatorState);
        //set the bar system value for the edit case
        isCalcInEditMode && setBarSystemValue(inputsArr.pop());
        const reqObj = {
          roofTypeId: inputsArr[0],
          constructionTypeId: inputsArr[1],
          bracketId: inputsArr[2],
          materialTypeId: inputsArr[3],
          fastenerTypeId: inputsArr[5],
          seamTypeId: inputsArr[4],
          sheathingTypeId: inputsArr[6],
          storeId: storeID
        };

        if (fieldSchema.label === 'Bracket Strength') {
          newState.value = await functions[fieldSchema.api](namesArr);
          setSystemComponents([]);
          const sysComps = await getSystemComponents(reqObj);
          setSystemComponents(sysComps);
          setUpdatedData(newState.data);
          setStrength(newState.value);
        }

        newState.apiCalled = true; // Update apiCalled flag
        // Update state
      }

      if (newState.data.length > 0 || !fieldSchema.api || newState.value) {
        let fieldEL = '';

        if (fieldSchema.type === fieldType.singleSelect) {
          fieldEL = (
            <CustomDropdown
              key={key}
              styles={{ width: '100%' }}
              sx={{
                mx: 0,
                display:
                  (fieldSchema.key === 'fastenerTypeId' &&
                    isNameInSate(fenceCalculatorState, 'Clamp', 2)) ||
                  (fieldSchema.key === 'constructionTypeId' &&
                    isNameInSate(fenceCalculatorState, 'Standing', 0))
                    ? 'none'
                    : 'inherit'
              }}
              value={fenceCalculatorState.get(key).value}
              onChange={(e) =>
                handleDropdownChange(key, e.target.value, newState.data, fieldSchema.type)
              }
              list={newState.data}
              name={newState.data[key]?.id}
              isId={true}
              label={fieldSchema.label}
              isRequired={true}
              disabled={readOnly}
            />
          );
        } else if (fieldSchema.type === fieldType.number) {
          fieldEL = (
            <Input
              sx={{ mx: 0, display: fieldSchema.disabled && 'none' }}
              type="number"
              key={key}
              defaultValue={fieldSchema.key === 'rainLoad' && 0}
              placeholder={fieldSchema.placeholder}
              value={fenceCalculatorState.get(key).value}
              onFocus={() => {
                isCalcInEditMode && setIsCalcInEditMode(false);
                if (fieldSchema.key != 'groundSnowLoad') setShowSnowLoadImage(false);
                else if (
                  fieldSchema.key == 'groundSnowLoad' &&
                  !isCalcInEditMode &&
                  (!isObjectEmpty(errors) || !outputs?.length > 0)
                )
                  setShowSnowLoadImage(true);
              }}
              onChange={(e) =>
                handleInputChange(
                  key,
                  e,
                  fieldSchema.key,
                  fieldSchema.type,
                  fieldSchema.min,
                  fieldSchema?.max
                )
              }
              required={fieldSchema?.required}
              readOnly={fieldSchema?.readOnly}
              disabled={fieldSchema?.disabled || readOnly}
              label={fieldSchema?.disabled ? fieldSchema.label + ' (lbs)' : fieldSchema.label}
              name={fieldSchema.label}
              onKeyDown={(event) => {
                preventChars(event);
                handleKeyDown(event);
              }}
              styleInput={stylesInput}
              description={fieldSchema.key == 'groundSnowLoad' ? 'Find Ground Snow Load at' : false}
              description2={
                fieldSchema.key == 'groundSnowLoad' ? 'UTAH ONLY - Find Ground Snow Load at' : false
              }
              error={errors[fieldSchema.key]}
            />
          );
          if (fieldSchema?.readOnly || fieldSchema.key === 'rainLoad') {
            addNextField(key);
          }
        }
        if (
          (fieldSchema.key === 'constructionTypeId' &&
            isNameInSate(fenceCalculatorState, 'Standing', 0)) ||
          (fieldSchema.key === 'fastenerTypeId' && isNameInSate(fenceCalculatorState, 'Clamp', 2))
        ) {
          addNextField(key);
        }

        setHtml((prevState) => {
          let tempHTML = [];
          if (!key == 0) {
            tempHTML = [...prevState];
          }
          tempHTML.length <= 12 && tempHTML.push(fieldEL);
          return [...tempHTML];
        });
      } else {
        addNextField(key);
      }
    }
  }

  const submitQuotation = async () => {
    setShowAlertBar(false);
    setErrorMessage([]);
    setEnableFinishBtn(false);
    const { reqObject, totalPrice } = getformattedCartData(cartData);
    const inputsArr = getArrayOfValuesFromMap(fenceCalculatorState);
    const requestParams = {
      userId: userData.userId,
      storeId: storeID,
      fenceQuotationId: fenceQuotationId,
      projectId: projectId,
      roofSectionId: roofId,
      roofType: inputsArr[0],
      constructionType: inputsArr[1],
      bracketType: inputsArr[2],
      bracketMaterial: inputsArr[3],
      sheathingType: inputsArr[6],
      fastenerType: inputsArr[5],
      seamType: inputsArr[4],
      manufacturer: '',
      model: '',
      gauge: '',
      groundSnowLoad: inputsArr[11],
      rainLoad: inputsArr[12],
      roofSlope: inputsArr[10],
      strength: inputsArr[7],
      lengthOfPanel: inputsArr[9],
      widthOfPanel: inputsArr[8],
      eaveLength: inputsArr[13],
      barSystem: barSystemValue,
      fencesNeeded: Math.ceil(outputs[0]),
      lengthRequiringOneFence: outputs[1],
      lengthRequiringTowFences: !isValidNumber(outputs[2]) ? null : outputs[2],
      distanceBetweenFences: !isValidNumber(outputs[3]) ? null : outputs[3],
      numberOfBrackets: !isValidNumber(outputs[5]) ? null : Math.ceil(outputs[5]),
      numberOfTubing: !isValidNumber(outputs[6]) ? null : Math.ceil(outputs[6]), // pipe quantity
      stopEndsAccessories: !isValidNumber(outputs[7]) ? null : outputs[7],
      iceFlags: !isValidNumber(outputs[8]) ? null : outputs[8],
      unitPrice: reqObject?.Bracket?.currentTierPrice,
      bracketTotalPrice: reqObject?.Bracket?.price,
      collarType: reqObject[SYSTEM_COMPONENT_TYPES.COLLAR]?.id,
      collarMaterial: reqObject[SYSTEM_COMPONENT_TYPES.COLLAR]?.materialId,
      numberOfCollars: Math.ceil(reqObject[SYSTEM_COMPONENT_TYPES.COLLAR]?.quantity),
      collarUnitPrice: reqObject[SYSTEM_COMPONENT_TYPES.COLLAR]?.currentTierPrice,
      collarTotalPrice: reqObject[SYSTEM_COMPONENT_TYPES.COLLAR]?.price,
      couplingType: reqObject[SYSTEM_COMPONENT_TYPES.COUPLING]?.id,
      couplingMaterial: reqObject[SYSTEM_COMPONENT_TYPES.COUPLING]?.materialId,
      numberOfCouplings: Math.ceil(reqObject[SYSTEM_COMPONENT_TYPES.COUPLING]?.quantity),
      couplingUnitPrice: reqObject[SYSTEM_COMPONENT_TYPES.COUPLING]?.currentTierPrice,
      couplingTotalPrice: reqObject[SYSTEM_COMPONENT_TYPES.COUPLING]?.price,
      pipeType: reqObject[SYSTEM_COMPONENT_TYPES.PIPE]?.id,
      pipeMaterial: reqObject[SYSTEM_COMPONENT_TYPES.PIPE]?.materialId,
      pipeUnitPrice: reqObject[SYSTEM_COMPONENT_TYPES.PIPE]?.currentTierPrice,
      pipeTotalPrice: reqObject[SYSTEM_COMPONENT_TYPES.PIPE]?.price,
      endCapType: reqObject[SYSTEM_COMPONENT_TYPES.STOP_END]?.id,
      endCapMaterial: reqObject[SYSTEM_COMPONENT_TYPES.STOP_END]?.materialId,
      numberOfStopEndsAccessories: Math.ceil(reqObject[SYSTEM_COMPONENT_TYPES.STOP_END]?.quantity),
      endCapUnitPrice: reqObject[SYSTEM_COMPONENT_TYPES.STOP_END]?.currentTierPrice,
      endCapTotalPrice: reqObject[SYSTEM_COMPONENT_TYPES.STOP_END]?.price,
      iceFlagType: reqObject[SYSTEM_COMPONENT_TYPES.ICE_FLAG]?.id,
      iceFlagMaterial: reqObject[SYSTEM_COMPONENT_TYPES.ICE_FLAG]?.materialId,
      numberOFIceFlags: Math.ceil(reqObject[SYSTEM_COMPONENT_TYPES.ICE_FLAG]?.quantity),
      iceFlagUnitPrice: reqObject[SYSTEM_COMPONENT_TYPES.ICE_FLAG]?.currentTierPrice,
      iceFlagTotalPrice: reqObject[SYSTEM_COMPONENT_TYPES.ICE_FLAG]?.price,
      totalPrice: totalPrice
    };

    setShowLoader(true);
    try {
      const questionSaved = await authPostRequest('saveFenceQuotation', requestParams);
      window.scrollTo(0, 0);
      if (questionSaved) {
        if (questionSaved.resStatus === 1) {
          setSuccessMessage([questionSaved.resMessage]);
          setTimeout(() => {
            navigate(-1);
          }, 2000);
        } else {
          setEnableFinishBtn(true);
          setErrorMessage([questionSaved.resMessage]);
        }
        setShowAlertBar(true);
      }
      setShowLoader(false);
    } catch (err) {
      setShowLoader(false);
      window.scrollTo(0, 0);
      console.log('error', err);
    }
  };

  // routing
  useEffect(() => {
    if (!storeID) {
      navigate('/Stores');
    } else if (!projectId) {
      navigate('/storeInfo/projects');
    } else if (!roofId) {
      navigate('/storeInfo/roof-section');
    }
  }, [roofId]);

  //for fields redering
  useEffect(() => {
    setHtml([]);
    setOutputs([]);
    processFenceCalculatorState();
    getBracketswithStorePrice();
  }, [fenceCalculatorState]);

  useEffect(() => {
    if (dataForCart && Object.keys(dataForCart)?.length > 0 && outputs?.length > 0) {
      let material = fenceCalculatorState.get(3)?.value;
      if (isCalcInEditMode) material = brktMaterialForEdit;
      setFenceInfo({
        eave_length: Number(inputsArray[5]),
        number_fence: Math.ceil(outputs[0]),
        length_of_panel: Number(inputsArray[1]),
        max_len_first: Number(outputs[1]),
        max_len_second: Number(outputs[2]),
        distance_first: isNaN(outputs[3]) ? 0 : Number(outputs[3].toFixed(2)),
        distance_second: isNaN(outputs[4]) ? 0 : Number(outputs[4].toFixed(2)),
        strength,
        clamp_deck_list: { qty: Math.ceil(outputs[5]) },
        end_caps_list: { qty: Math.ceil(outputs[7]) },
        collars_list: { qty: Math.ceil(outputs[7]) },
        tube_list: { qty: Math.ceil(outputs[6]) },
        ice_flag_list: { qty: Math.ceil(outputs[8]) },
        tube_system: Math.ceil(outputs[6]),
        width_of_panel: Number(inputsArray[0])
      });
      setCartData(
        setCartDataforAdd(
          dataForCart,
          fenceCalculatorState.get(2)?.value,
          material,
          outputs,
          systemComponents,
          isCalcInEditMode,
          barSystemValue,
          selectedBrktPrice
        )
      );
    }
  }, [
    dataForCart,
    fenceCalculatorState,
    isCalcInEditMode,
    outputs[5],
    systemComponents,
    selectedBrktPrice
  ]);

  useEffect(() => {
    if (priceList?.length > 0) {
      sortFences(
        priceList,
        sortByMaterial,
        setUpdatedData,
        fenceCalculatorState,
        setDataForCart,
        isCalcInEditMode,
        setBarSystemValue
      );
    }
  }, [sortByMaterial, fenceCalculatorState]);

  //for output call output function and pass the values
  useEffect(() => {
    setEnableFinishBtn(false);
    const keys = Object.keys(errors);
    const notNullKeys = keys.filter((key) => errors[key] !== null);

    if (inputsArray?.length > 5 && strength) {
      const inputs = inputsArray.map((input) => input?.toString());
      const filteredInputs = inputs.filter((value) => value !== '');
      const outputs = combineFenceOutput(
        inputs[0],
        inputs[1],
        inputs[2],
        inputs[3],
        inputs[4],
        inputs[5],
        barSystemValue,
        strength
      );

      setOutputs(outputs);
      const isValid = !outputs.includes('error') && !outputs.includes(Infinity);
      if (filteredInputs.length > 5 && isValid && notNullKeys?.length == 0)
        setEnableFinishBtn(true);
    }
  }, [inputsArray, errors, barSystemValue]);

  useEffect(() => {
    if (outputs?.length > 0) setShowSnowLoadImage(false);
  }, [outputs]);

  const getQuotaion = async () => {
    let isEditMode = false;
    setFenceQuotationId(null);
    try {
      setShowLoader(true);
      const quotaionRes = await authPostRequest('getFenceQuotationByRoofSection', {
        roofSectionId: roofId
      });

      if (quotaionRes) {
        if (quotaionRes.resStatus === 1) {
          setShowLoader(true);
          setIsCalcInEditMode(true);
          const quotaion = quotaionRes.fenceQuotationsList[0];
          const targetObject = getObjectWithValidValues(quotaion);

          const filteredMap = new Map();
          const outputData = [];

          fenceCalculatorUIFieldStructure.forEach((field, i) => {
            const fieldState = {
              ...schema,

              value: targetObject[field?.key],
              name: targetObject[field?.name]
            };
            filteredMap.set(i, fieldState);
          });

          outputArray.forEach((field) => {
            outputData.push(targetObject[field.name]);
          });
          setBrktMaterialForEdit({
            material: quotaion?.bracketMaterial,
            brktPrice: quotaion?.unitPrice,
            bracketTypeId: quotaion?.bracketTypeId,
            bracketMaterialId: quotaion?.bracketMaterialId
          });
          setFenceCalculatorState(filteredMap);
          setOutputs(outputData);
          setFenceQuotationId(quotaion?.fenceQuotationId);
          isEditMode = true;

          if (isEditMode && filteredMap.size > 14 && outputData)
            setTimeout(() => {
              setShowLoader(false);
            }, [5000]);
        }
        !isEditMode && setShowLoader(false);
      }
    } catch (err) {
      setShowLoader(false);
      console.log('error', err);
    }
  };

  useEffect(() => {
    getQuotaion();
  }, []);

  //for image rendering fetch current array and key
  const key = fenceCalculatorState.size - 1;

  return (
    <Grid container>
      {showLoader && <Loader open={showLoader} />}
      {showAlertBar && (
        <SuccessError
          successMessage={successMessage}
          errorMessage={errorMessage}
          setShowAlertBar={setShowAlertBar}
        />
      )}
      <Grid item xs={12} display="flex" justifyContent="space-between">
        <BackButton
          onClick={() =>
            navigate('/StoreInfo/roof-section', {
              state: {
                index: {
                  id: projectId,
                  name: projectName,
                  description: roofState?.projectDescription
                }
              }
            })
          }
        />
        <CalculatorCart disabled={!enableFinishBtn} cartData={cartData} />
      </Grid>
      <RoofSectionHeader
        roofId={roofId}
        projectId={projectId}
        roofName={roofName}
        price={roofData?.price}
        roofDescription={roofDescription}
        setErrorMessage={setErrorMessage}
        setSuccessMessage={setSuccessMessage}
        setShowAlertBar={setShowAlertBar}
        setShowLoader={setShowLoader}
        quotationTypeId={58}
      />
      <Grid item xs={12} display="flex" justifyContent="flex-end" sx={{ width: 400 }}>
        {key === 2 && (
          <SortDropdownFence
            setSortByMaterial={setSortByMaterial}
            sortByMaterial={sortByMaterial}
          />
        )}
      </Grid>
      <Grid item xs={4} sx={{ width: 400 }}>
        {html}
      </Grid>
      <Grid
        item
        spacing={4}
        xs={8}
        display="flex"
        sx={{
          minHeight: '75vh',
          backgroundColor: 'white',
          flexWrap: 'wrap',
          py: 2,
          pl: 4,
          width: '100%',
          alignContent: 'flex-start'
        }}>
        {showSnowLoadImage && <SnowloadImage />}
        {updatedData?.length > 0 &&
          !isCalcInEditMode &&
          !readOnly &&
          !isClampOnFastener &&
          !isStandingSeamConstruction && (
            <RenderOptionImages
              data={updatedData}
              allowSecondClick={allowSecondClick}
              handleDropdownChange={handleDropdownChange}
              lastClickTime={lastClickTime}
              setLastClickTime={setLastClickTime}
              handleDropdownChangeMaterial={handleDropdownChangeMaterial}
              CalcKey={key}
            />
          )}
        {outputs?.length > 0 && isObjectEmpty(errors) && (
          <Grid
            justifyContent="center"
            alignItems="center"
            sx={{ marginTop: enableGraph ? '' : '50%', overflow: 'auto' }}>
            <Grid ref={contentRef} id="fence_results" sx={{ left: '2vh' }}>
              {enableGraph && (
                <Grid sx={{ ml: '5px' }}>
                  <FenceDiagram fenceInfo={fenceInfo} height={460} width={600} />
                </Grid>
              )}
              <Text
                variant="h5"
                style={{
                  color: style.LIGHT.primary,
                  marginLeft: '5px',
                  fontWeight: 'bold'
                }}>
                Outputs
              </Text>
              {outputArray.map((val, index) => (
                <Grid
                  key={val.name}
                  display="flex"
                  justifyContent="space-between"
                  sx={{
                    mt: '1vh',
                    ml: '1vh',
                    width: '90%'
                  }}>
                  <Text sx={{ fontWeight: 'bold' }}>{val.label}:</Text>
                  <Text>
                    {isValidNumber(outputs[index])
                      ? index === 0 || index > 4
                        ? Math.ceil(parseFloat(outputs[index]))
                        : parseFloat(outputs[index]).toFixed(1)
                      : 'NA'}
                  </Text>
                </Grid>
              ))}
            </Grid>
            <SaveScreenshot
              setShowLoader={setShowLoader}
              displayText="Save Results"
              enableBtn={readOnly || enableFinishBtn}
              contentRef={contentRef}
            />
          </Grid>
        )}
      </Grid>
      {!readOnly && (
        <Grid xs={12} display="flex" justifyContent="flex-end">
          <CustomButton
            sx={{ mt: 2, mb: 0, mx: 0 }}
            type="button"
            endIcon={<ArrowForward />}
            disabled={!enableFinishBtn}
            onClick={submitQuotation}>
            Finish Project
          </CustomButton>
        </Grid>
      )}
    </Grid>
  );
};

export default FenceCalculator;
